

import React from 'react';
import Row from 'react-bootstrap/Row';
import { constants } from '../../../../constants/constants'

export default function returnHeader(stage) {
    if (stage === "USED"){
        return UsedHeader
    } else if (stage === "EXPIRED"){
        return ExpiredHeader
    } else if (stage === "INVALID"){
        return InvalidHeader
    } else if (stage === "ERROR"){
        return ErrorHeader
    }
}

const UsedHeader =
<div role="banner">
<h1 className="title__TO block" style={{'marginBottom': '30px', 'marginTop': '79px'}}>
    {constants.PASSWORD_USED_TITLE}
</h1>
</div>

const ExpiredHeader =
<div role="banner">
<h1 className="title__TO block" style={{'marginBottom': '29px', 'marginTop': '80px', 'width':'auto'}}>
{constants.PASSWORD_EXPIRED_SUBTITLE}
</h1>
</div>

const InvalidHeader =
<div role="banner">
<h1 className="title__TO block" style={{'marginBottom': '29px', 'marginTop': '84px', 'width':'auto'}}>
    {constants.PASSWORD_INVALID_TITLE}
</h1>
</div>

const ErrorHeader =
<div role="banner">
<h1 className="title__TO block" style={{'marginBottom': '29px', 'marginTop': '124px', 'width':'auto'}}>
    {constants.PASSWORD_ERROR_TITLE}
</h1>
</div>